import React from "react"
import PropTypes from "prop-types"
import ModalForm from "../../../../components/compounds/modalForm/ModalForm.compunds"
import BeachAccessOutlinedIcon from "@mui/icons-material/BeachAccessOutlined"
import VacationRequestSummary from "../../components/VacationRequestSummary.molecule"
import Divider from "../../../../components/atoms/Divider.atom"
import GridContainer from "../../../../components/layouts/containers/GridContainer.container"
import GridItem from "../../../../components/layouts/containers/GridItem.container"
import { ValueWithLabelTemplate } from "../../../../components/layouts/containers/ValueWithLabelElements.container"
import {
  getVacationState,
  isVacationRequestCanceled,
  isVacationRequestCanceledByAdmin,
  isVacationRequestRejected,
} from "../../../../utils/vacation.utils"
import VacationStatusChip from "../../../../components/molecules/VacationStatusChip.molecule"

const ModalFormRejectedRequestReview = ({
  visible,
  setVisible,
  selectedVacationRequest,
}) => {
  if (!selectedVacationRequest) {
    return null
  }
  return (
    <>
      <ModalForm
        className="vacation-approved-review-modal-form"
        headerTitle="Solicitud de vacaciones"
        withoutFooter
        headerIcon={
          <BeachAccessOutlinedIcon
            style={{ color: "var(--clr-info__dark)", fontSize: "32px" }}
          />
        }
        visible={visible}
        setVisible={setVisible}
        dismissableMask
        closable
      >
        <VacationRequestSummary vacationRequest={selectedVacationRequest} />
        <Divider stroke="sm" />
        <GridContainer className="state-form">
          <GridItem col={6}>
            <ValueWithLabelTemplate
              label="Estado"
              value={
                <VacationStatusChip
                  status={getVacationState(selectedVacationRequest)}
                  variant="long"
                />
              }
            />
          </GridItem>
          <GridItem col={6}>
            <ValueWithLabelTemplate
              label="Responsable"
              value={selectedVacationRequest?.approver?.fullName}
            />
          </GridItem>
          {(isVacationRequestCanceledByAdmin(selectedVacationRequest) ||
            isVacationRequestRejected(selectedVacationRequest)) && (
            <GridItem col={12}>
              <ValueWithLabelTemplate
                label={
                  isVacationRequestCanceled(selectedVacationRequest) ?
                    "Motivo de cancelación"
                  : "Motivo de rechazo"
                }
                value={selectedVacationRequest.cancelationMotive}
              />
            </GridItem>
          )}
        </GridContainer>
      </ModalForm>
    </>
  )
}

export default ModalFormRejectedRequestReview

ModalFormRejectedRequestReview.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  selectedVacationRequest: PropTypes.object,
}
